import PropTypes from 'prop-types';
import { BsCheckCircleFill, BsPencil, BsPersonPlus, BsTrash, BsXCircle } from 'react-icons/bs';

import Menu from '#globalComponents/Overlay/Menu';
import Popover from '#globalComponents/Overlay/Popover';

const PlannedActionsMenu = ({
	activity,
	isCampaign,
	onEdit,
	onComplete,
	onReassign,
	onCancelAutomated,
	onDelete,
	onClose,
	anchorRef,
}) => (
	<Popover open onClose={onClose} anchorRef={anchorRef} size="s" align="end">
		<Menu>
			{!isCampaign && (
				<Menu.Item onClick={onEdit} icon={BsPencil}>
					Bearbeiten
				</Menu.Item>
			)}
			{!activity.isAutomated && (
				<Menu.Item onClick={onComplete} icon={BsCheckCircleFill}>
					Als erledigt
				</Menu.Item>
			)}
			{!activity.isAutomated && (
				<Menu.Item onClick={onReassign} icon={BsPersonPlus}>
					Neu zuweisen
				</Menu.Item>
			)}
			<Menu.Separator />
			{activity.isAutomated ? (
				<Menu.Item onClick={onCancelAutomated} icon={BsXCircle}>
					<span className="text-warning-700">Abbrechen</span>
				</Menu.Item>
			) : (
				<Menu.Item onClick={onDelete} icon={BsTrash}>
					<span className="text-warning-700">Löschen</span>
				</Menu.Item>
			)}
		</Menu>
	</Popover>
);

PlannedActionsMenu.propTypes = {
	activity: PropTypes.object.isRequired,
	isCampaign: PropTypes.bool.isRequired,
	onEdit: PropTypes.func.isRequired,
	onComplete: PropTypes.func.isRequired,
	onReassign: PropTypes.func.isRequired,
	onCancelAutomated: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	anchorRef: PropTypes.shape({ current: PropTypes.any }),
};

export default PlannedActionsMenu;
